import React, { useMemo } from 'react';
import styles from './FocusCardRep.module.scss';
import icon_Focus_LP from 'assets/learningPaths/icon-Focus-LP.svg';
import { imageBasePath } from 'constants';
import { format, parseISO } from 'date-fns';
import DeadlineBubble from '../common/DeadlineChip';
import { useLearningPathsStore } from '../../LearningPaths.store';
import icon_arrow_active from 'assets/learningPaths/Arrow_active.svg';
import person_skill_active from 'assets/learningPaths/person_skill_active.svg';
import { useStartLearningPathMutation } from '../../LearningPaths.queries';

const FocusCardRepComponent = ({
  learningPath = {},
  completed = 1,
  completedStyles_ = null,
  module_completion = 0,
  setInProgress = null,
  isInProgress = false,
}) => {

  const { setSelectedRepLearningPathID } = useLearningPathsStore();
  const completedStyles = useMemo(
    () => ({
      left: 0,
      width: '100%',
    }),
    []
  );
  return (
    <div
      className={styles.container}
      onClick={() => {
        if (isInProgress) {
          setInProgress({ uuid: learningPath?.uuid })
        }
        setSelectedRepLearningPathID(learningPath?.uuid)
      }}
    >
      <div className={styles.main}>
        <div className={styles.FocusMainText}>
          <div className={styles.FocusHeaderText}>
            <img src={icon_Focus_LP} alt="icon" className={styles.icon} />
            <div className={styles.headerTextTitle}>{learningPath?.title}</div>
          </div>
          {learningPath?.description.length > 0 ? (
            <div className={styles.FocusDescription}>{learningPath?.description}</div>
          ) : (
            <div className={styles.focusNoDescription}>No description provided</div>
          )}
          <div className={styles.FocusBubblesContainer}>
            <div>
              <img src={person_skill_active} alt="icon" />
              {`${learningPath?.created_by.first_name} ${learningPath?.created_by.last_name}`}
            </div>
            {learningPath?.updated_at && (
              <div>
                <img src={`${imageBasePath}UpdatedActive.svg`} alt="icon" />
                Updated on {format(parseISO(learningPath?.updated_at), 'MMM dd, yyyy')}{' '}
              </div>
            )}
            <div>
              <img src={`${imageBasePath}contentActiveDesign.svg`} alt="icon" />
              {learningPath?.total_contents} Skill Sets
            </div>
          </div>
          {(completed === 1 || completed === 2) && (
            <div>
              <div className={styles.progressBar}>
                <div
                  className={styles.completed}
                  style={
                    completed === 2
                      ? completedStyles_
                      : completedStyles_
                        ? completedStyles_
                        : completedStyles
                  }
                />
              </div>
              <div className={styles.progressBarText}>
                <div className={styles.progressBarTitle}>Overall Completion</div>
                <div className={styles.progressBarTitle}>{module_completion || 100}%</div>
              </div>
            </div>
          )}
          <div className={styles.focusFooter}>
            <div className={styles.focusFooterIndicators}>
              {completed === 1 && <span className={styles.completedTag}>Completed</span>}
              <DeadlineBubble deadline={learningPath?.deadline} />
            </div>
            <div
              className={styles.focusContinue}
              onClick={() => {
                if (isInProgress) {
                  setInProgress({ uuid: learningPath?.uuid })
                }
                setSelectedRepLearningPathID(learningPath?.uuid)
              }}
            >
              <span>{completed === 1 ? 'See Skill Sets' : 'Start Learning'}</span>
              <img src={icon_arrow_active} alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FocusCardRepComponent;
